const DECIMAL = 3;
/**
 * Rounds a number string to two decimal places.
 *
 * @param {string|number} numberString - The number string to round.
 * @returns {string} The rounded number as a string with two decimal places.
 * @example
 * Returns "2.72"
 * roundup("2.71828");
 *
 * @example
 * Returns "5.00"
 * roundup("5");
 */
export const roundup = (numberString: string | number | undefined): string => {
	if (!numberString) return Number(0).toFixed(DECIMAL);

	// Parse the string to a floating point number
	let number: number = parseFloat(numberString.toString());

	// Check if the parsed number is a valid number
	if (isNaN(number)) {
		return 'Invalid number';
	}

	// Round the number to two decimal places
	let roundedNumber: number = Math.round(number * 100) / 100;

	// Convert the rounded number back to a string
	return roundedNumber.toFixed(DECIMAL);
};
